import { render, staticRenderFns } from "./PageNumberSelector.vue?vue&type=template&id=ad631baa&scoped=true&"
import script from "./PageNumberSelector.vue?vue&type=script&lang=ts&"
export * from "./PageNumberSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad631baa",
  null
  
)

export default component.exports